import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoFingerTap = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>FingerTap</title>
    <path
      d="M16.438 17.99V8.36c0-.946-.767-1.714-1.714-1.714v0c-.947 0-1.715.768-1.715 1.714V20.68"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.009 15.407c-3.266 0-2.86 4.61-2.86 6.21-.001 1.6.381 2.315 1.031 3.354.934 1.495 2.4 3.4 2.4 3.4v3.417h9.715l.571-3.174c1.427-1.154 2.286-3.544 2.286-4.445v-4.952c0-1.905-1.588-2.866-2.857-2.54m0 0c0-.635-1.743-2.06-3.429-1.27m3.429 1.27v1.905m-3.429-3.175c0-.635-1.181-1.827-2.857-1.27m2.857 1.27v2.54M9.748 8.033h-1.14M20.837 8.033h-1.14M10.989 4.576l-.807-.805M14.775 3.302v-1.14M18.491 4.577l.807-.806"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoFingerTap;
